module.exports = __webpack_public_path__ + "img/sw4-b1.f022ad76.jpg";